<template>
	<div>
		<alert v-if="basketEmptied" type="warning">
			<div class="d-flex flex-column flex-sm-row">
				<p class="mb-2 mb-sm-0 text-start"><b>Tyres removed!</b> - It isn't possible to add both fully fitted and delivered tyres to your order. Any tyres you had previously selected have been removed from your basket.</p>
			</div>
		</alert>
		<div class="col-12" v-if="updatedFeaturedTopSpot">
			<div class="mb-3">
				<your-vehicle
					v-if="registration != null"
					:registration="registration"
					:make="make"
					:model="model"
					:colour="colour"
					:image-base-path="imageBasePath"
					:postcode="updatedPostcode"
					:size-options="sizeOptions"
				></your-vehicle>
				<div class="row">
					<check-availability
						:postcode="this.updatedPostcode"
						@updatedPostcode="updatePostcode"
					></check-availability>
				</div>
			</div>
		</div>
		<div class="row" v-if="updatedFeaturedTopSpot">
			<featured-top-spot
				v-if="updatedFeaturedTopSpot"
				:tyre="updatedFeaturedTopSpot"
				:postcode="this.updatedPostcode"
				:basket="updatedBasket"
				:banners="banners"
				:home-delivery="homeDelivery"
				:is-uber="is_uber"
			></featured-top-spot>
			<teleport to="body">
				<basket-modal
					:basket="this.updatedBasket"
					:modal-open="modalOpen"
					:postcode="updatedPostcode"
					:tyre-position="tyrePosition"
					:size-options="sizeOptions"
					@closeModal="modalOpen = false"
				></basket-modal>
				<upsell-modal
					:current-tyre="this.currentTyre"
					:upsold-tyre="upsoldTyre"
					:upsell-details="upsellDetails"
					:upsell-modal-open="upsellModalOpen"
					:image-base-path="imageBasePath"
					@closeModal="upsellModalOpen = false"
				></upsell-modal>
				<info-modal></info-modal>
			</teleport>
		</div>
		<div class="row" v-else>
			<h2 class="h3 mt-3 mb-2 col-12">Sorry, we don't currently have your size available</h2>
			<div class="col-12 col-lg-8 col-xl-6">
				<p class="my-3">We're working hard to expand the ENSO tyres range to cover more sizes and vehicles. As a new brand focused on innovation and sustainability, development takes time - but we're getting there.</p>
				<p>In the meantime, you can still find tyre options in your size at our trusted partner <b>etyres.co.uk</b>, with convenient fitting options available nationwide.</p>
				<div class="border p-3 rounded-16 mb-3">
					<div class="text-center text-black p-2 mb-3 rounded-32" style="background: rgb(238, 210, 103);">
                        <b class="d-block d-sm-inline-block me-sm-2">Get up to £20 off -</b>
                        <span>Follow the link for details</span>
                    </div>
					<div class="d-flex flex-column flex-sm-row align-items-center justify-content-between">
						<div class="d-flex align-items-center flex-column flex-sm-row">
							<img src="/assets/img/generic_images/etyres-logo.png" style="max-width: 120px;" alt="etyres" />
							<p class="ms-sm-3 my-3 my-sm-0 mb-sm-0">Browse tyres in size <b>{{ tyreSize }}</b></p>
						</div>
						<a :href="'https://etyres.co.uk/' + tyreSize.match(/\d+/g).join('-') + '?utm_source=enso&utm_medium=cta&utm_campaign=uber'" target="_blank" class="btn btn-primary d-flex align-items-center">Shop now <i class="fa-solid fa-arrow-right ms-2"></i></a>
					</div>
				</div>
				<p>Thank you for your patience - we're excited to bring you more ENSO options soon.</p>
			</div>
		</div>
	</div>
</template>

<script>
    import url_filters from '@shared/mixins/url_filters';
    import basket from '@shared/mixins/basket';

	export default {
	    props: [
			'featuredTopSpot',
			'basket',
			'banners',
			'totalTyres',
			'tyreSize',
			'postcode',
			'imageBasePath',
			'selectTyresTakeover',
			'homeDeliveryRoute',
			'tyrePosition',
			'sizeOptions',
			'tyreSizeContent',
			'customTyreUrl',
			'registration',
			'payWithPaypal',
			'make',
			'model',
			'colour',
			'is_uber'
		],
		mixins: [url_filters, basket],
	    data() {
	        return {
	            modalOpen: false,
	            updatedBasket: this.basket,
				updatedFeaturedTopSpot: this.featuredTopSpot,
				updatedFeaturedTyres: this.featuredTyres,
				updatedTopChoices: this.moreTopChoices,
				updatedTyres: this.tyres,
				updatedTotalTyres: this.totalTyres,
				updatedFilters: this.filters,
				sortValue: '',
				updatedPostcode: this.postcode,
				basketEmptied: false
			}
	    },
	    mounted() {
			//removes loading placeholder - fixes CLS issue
			document.querySelector('#loadingPlaceholder').style.display = 'none';

			this.updateAllTyreFittingAvailability();

            this.emitter.on('basketEmptied', data => {
                this.basketEmptied = true;
            });
	    },
	    methods: {
			updatePostcode(value) {
				this.updatedPostcode = value;
			}
	    },
	    computed: {
	    },
		watch: {
        }
	}
</script>